export default {
    Region: process.env.VUE_APP_AWS_REGION,
    UserPoolId: process.env.VUE_APP_AWS_USERPOOL_ID,
    ClientId: process.env.VUE_APP_AWS_CLIENT_ID,
    IdentityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    ApiEndpoint: process.env.VUE_APP_API_ENDPOINT,
    Env: process.env.VUE_APP_ENVIRONMENT,
};
